import { Button, EmptyState, WarningIcon } from '@/shared/ui/atoms';
import { selectParticle } from '@/shared/lib/getParticle';

export interface DataLoadErrorProps {
  /** 못 불러온 대상. 조사는 붙이지 말 것 — "채널 목록", "구성원 정보" */
  subject: string;
  /** 기본 안내를 덮어쓸 때만 지정 */
  description?: string;
  /** 주면 "다시 시도" 버튼이 붙는다. 대개 react-query 의 refetch */
  onRetry?: () => void;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const DEFAULT_DESCRIPTION = '잠시 후 다시 시도해 주세요.';

/**
 * 조회 실패 안내 — 빈 결과와 구분되지 않던 실패 화면의 단일 표현.
 * 빈 상태(EmptyState)와 같은 배치를 쓰되 경고 아이콘과 role="alert" 로 실패임을 알린다.
 */
export function DataLoadError({
  subject,
  description = DEFAULT_DESCRIPTION,
  onRetry,
  size = 'md',
  className,
}: DataLoadErrorProps) {
  return (
    <div role="alert" className={className}>
      <EmptyState
        icon={<WarningIcon />}
        title={`${subject}${selectParticle(subject, '을', '를')} 불러오지 못했습니다`}
        description={description}
        size={size}
        action={
          onRetry ? (
            <Button type="button" variant="secondary" size="sm" onClick={onRetry}>
              다시 시도
            </Button>
          ) : undefined
        }
      />
    </div>
  );
}
